import React, { useState } from 'react';

export default function Faq() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div>
      <style>
        {`
        
.pq-section.pq-style-1.text-center {
  text-align: center;
  margin-bottom: 20px;
}

.pq-section-sub-title {
  font-size: 18px;
  color: #666;
  display: block;
  margin-bottom: 10px;
}

.pq-section-title {
  font-size: 28px;
  color: #333;
  font-weight: 600;
}


.pq-accordion-block {
  width: 100%;
}

.pq-accordion-box {
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 10px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.pq-accordion-box.active {
  border-color: #239857;
}

.pq-ad-title {
  padding: 15px;
  background-color: #f9f9f9;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ad-title-text {
  font-size: 16px;
  color: #333;
  margin: 0;
  flex: 1;
}

.pq-accordion-details {
  padding: 0 15px;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease, padding 0.3s ease;
}

.pq-accordion-details.open {
  padding: 15px;
  max-height: 500px; 
}

.pq-detail-text {
  font-size: 14px;
  color: #555;
  line-height: 1.6;
  margin: 0;
}

.fa {
  font-size: 14px;
  color: #239857;
  transition: transform 0.3s ease;
}

.fa-chevron-down {
  transform: rotate(0deg);
}

.fa-chevron-up {
  transform: rotate(180deg);
}
.pq-accordion-block .pq-accordion-box .pq-accordion-details {
  padding: 0 20px  !important;
  border: 1px solid var(--grey-color);
  border-top: 0;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}
`}
      </style>
      <section className="faq">
        <div className="container py-4">
          <div className="row">
				
              <div className="col-md-7">
					
					<div className="pq-section pq-style-1 text-center">
					  <h2 className="pq-section-title">Frequently Asked Questions (FAQ’s)</h2>
					</div>
					
					<div className="col-xl-12 mt-xl-0 ps-xl-3">
					  <div className="pq-accordion-block mt-4">
						{[ 
						  { question: "What is Stapedectomy surgery?", answer: "Stapedectomy is a delicate ear surgery done to treat hearing loss caused by otosclerosis. In this condition, the stapes bone becomes fixed and cannot vibrate properly. During the procedure, the damaged stapes is removed and replaced with a tiny prosthesis that restores sound transmission to the inner ear, helping improve hearing clarity and daily communication." },
						  { question: "Who needs Stapes/Stapedectomy surgery?", answer: "This surgery is recommended for patients with conductive hearing loss due to otosclerosis—when the stapes bone becomes stiff. If you have reduced hearing, trouble understanding speech, or abnormal hearing test results, an ENT specialist may advise Stapedectomy. Audiometry and a detailed ear examination confirm whether you are a suitable candidate." },
						  { question: "Is Stapedectomy a safe procedure?", answer: "Yes, Stapedectomy is considered a safe and effective surgery when performed by an experienced ENT surgeon. It has a high success rate and can significantly improve hearing. While risks are minimal, they may include dizziness, temporary taste changes, or rare hearing fluctuations. Your doctor will explain everything before the procedure for full clarity." },
						  {question: "How long does recovery take after Stapedectomy?", answer: "Most patients recover quickly and return to routine activities within a week. Some mild dizziness or ear fullness may occur initially. Hearing improvement usually starts a few days or weeks after surgery and continues as the ear heals. It's important to avoid water entry, loud noise, and heavy lifting until your doctor gives clearance."},
						  {question: "Are the results of Stapedectomy permanent?", answer: "Stapedectomy generally provides long-lasting improvement in hearing. The prosthesis used to replace the stapes remains stable for many years. However, age-related or nerve-related hearing changes can still occur over time. Regular checkups with your ENT specialist help ensure continued ear health and monitor overall hearing quality."}
						].map((item, index) => (
						  <div className={`pq-accordion-box ${activeIndex === index ? 'active' : ''}`} key={index}>
							<div className="pq-ad-title" onClick={() => toggleAccordion(index)}>
							  <h4 className="ad-title-text">
								{item.question}
								<i className={`fa ${activeIndex === index ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
							  </h4>
							</div>
							<div className={`pq-accordion-details ${activeIndex === index ? 'open' : ''}`}>
							  <p className="pq-detail-text">{item.answer}</p>
							</div>
						  </div>
						))}
					  </div>
					</div>
				</div>
				<div className="col-md-5 m-auto">
                  <div className="card shadow-lg">
                      <iframe width="100%" height="300px" src="https://www.youtube.com/embed/mCZCoSGGtK4" title="Tonsillectomy" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen ></iframe>
                       <div class="p-3"><h5 class="text-success mb-0">Stapes Surgery For Hearing Loss | बहरापन के लिए स्टैप्स सर्जरी | Dr. Major Rajesh Bhardwaj</h5></div>                 
				 </div>
              </div>
          </div>
        </div>
      </section>
    </div>
  );
}
